<template>
	<th class='form_td field_tooltip_parent' @click='showTooltip'>
    	<slot></slot>
		<div class='field_tooltip' :class='{"visible": tooltipIsVisible}'>
			<span>Установить для всех участков</span>
			<button type="button" @click='sendAccordance'>
				<CheckIcon class="icon"/> Соответствие
			</button>
			<button type="button" @click='sendNotAccordance'>
				<CancelIcon class="icon"/> Несоответствие
			</button>
		</div>
    </th>
</template>

<script>
	import {DB} from './../../../constants'

	import {EventBus} from '../../../lib/EventBus'

	import CancelIcon from '@/assets/CancelIcon'
	import CheckIcon from '@/assets/CheckIcon'

	export default {
		name: 'warrantTableField',
		data: function () { 
			return {
				tooltipIsVisible: false 
			}
		},
		components: {
			CheckIcon, CancelIcon
		},
		computed: {
			slotText () {
				return this.$slots.default[0].text 
			}
		},
		props: {
			field_name: ''
		},
		methods: {
			showTooltip () {
				EventBus.$emit('closeOtherTooltip')
				this.tooltipIsVisible = true
			},
			hideTooltip (e) {
				if(e && (e.target.classList.contains('field_tooltip_parent') || e.target.classList.contains('field_tooltip')))
					return 0

				this.tooltipIsVisible = false
			},
			sendAccordance () {
				this.$emit('set', {field: this.field_name, value: 1})
			},
			sendNotAccordance () {
				this.$emit('set', {field: this.field_name, value: 0})
			}
		},
		created() {
			window.addEventListener('click', this.hideTooltip)
			EventBus.$on('closeOtherTooltip', this.hideTooltip)
		},
		beforeDestroy() {
			window.removeEventListener('click', this.hideTooltip)
			EventBus.$off('closeOtherTooltip')
		}
	}
</script>

<style scoped>
.form_td {
	position: relative;
}

.form_td:hover {
	background: #f5f5f5;
}

.form_td .field_tooltip {
  visibility: hidden;
  width: 220px;
  font-size:13px;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  border-radius: 6px;
  top: -113px;
  left: calc(-110px + 50%);
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
}

.form_td .field_tooltip:after {
	position:absolute;
	bottom: -20px;
	right: calc(50% - 20px);
	content: ' ';
	border-left: 20px solid transparent;
  	border-right: 20px solid transparent;
  	border-top: 20px solid black;
}

.field_tooltip.visible { 
  visibility: visible;
}

.icon {
	height: 18px;
	vertical-align: middle;
}

button {
	font-size: 11px;
    height: 24px;
    width: 135px;
    background: #fcfcfc;
    color: black;
    border: 2px solid #fff;
    margin: 4px;
}

button:hover {
	background: #f0f0f0;
}
</style>


// WEBPACK FOOTER //
// warrantTableField.vue?38229876